import { h, render, Fragment } from 'preact';
import 'swiper/swiper.min.css';
import { useMemo, useState, useEffect } from 'preact/hooks';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper';
import Image from '../utils/image';
import ArrowIcon from '../utils/icons/arrow.svg';

/**
 * element: DOM node representing the component
 * data: info scraped from data-section-data element.
 * This should be a application/json type script tag.
 * data.layout: access to the media query utility
 *
 * Architecture within each component is very flexible,
 * but let's try to keep it as functional as possible.
 */

export default (element) => {
  const init = () => {
    render(<Specs />, element);
  };

  const Specs = () => {
    const [currentProduct, setCurrentProduct] = useState(null);

    useEffect(() => {
      document.addEventListener('product:updated', (e) => {
        setCurrentProduct(e.detail.payload.product);
      });

      document.addEventListener('product:init', (e) => {
        setCurrentProduct(e.detail.payload.product);
      });
    }, []);

    const specData = useMemo(() => {
      // eslint-disable-next-line prefer-const
      let formattedSpecs = [];
      currentProduct?.imageSpecMetafields.forEach((item) => {
        if (item) {
          formattedSpecs[item.key] = item.value;
        }
      });

      return formattedSpecs;
    }, [currentProduct]);

    const handleSpecPanelOpen = () => {
      const openFlyoutEvent = new CustomEvent('flyout:open', {
        detail: {
          specificationsData: currentProduct.specsMetafields,
        },
      });
      document.dispatchEvent(openFlyoutEvent);
    };

    return (
      <>
        {(specData.overview_text || specData.spec_1_image) && (
          <div className="pt-[60px] pl-5 pr-0 laptop:pl-9">
            {(specData.overview_text || specData.cta_copy) && (
              <div class="mb-[30px] pr-5 laptop:pr-0 laptop:mx-10 laptop:ml-0 laptop:mb-10  laptop:flex items-end laptop:pb-10 laptop:border-b border-primary-1">
                {specData.overview_text && (
                  <p className="subheading-1 text-primary-1 -tracking-[0.6px] mb-8 laptop:basis-7/12 laptop:mb-0">
                    {specData.overview_text}
                  </p>
                )}
                {specData.cta_copy && (
                  <div className="laptop:basis-5/12 laptop:flex laptop:justify-end">
                    {specData.cta_link && (
                      <a
                        href={specData.cta_link}
                        className="btn-primary-stroke-arrow w-full tablet:w-[300px] !bg-transparent h-fit laptop:mb-2.5"
                      >
                        {specData.cta_copy}
                      </a>
                    )}
                    {!specData.cta_link && (
                      <button
                        className="btn-primary-stroke-arrow w-full tablet:w-[300px]  !bg-transparent h-fit laptop:mb-2.5"
                        onClick={handleSpecPanelOpen}
                      >
                        {specData.cta_copy}
                      </button>
                    )}
                  </div>
                )}
              </div>
            )}
            <div className="relative">
              <Swiper
                slidesPerView={1.06}
                speed={400}
                spaceBetween={5}
                modules={[Navigation]}
                navigation={{
                  nextEl: '.swiper-button-next-image-spec',
                  prevEl: '.swiper-button-prev-image-spec',
                }}
                breakpoints={{
                  992: {
                    slidesPerView: 1.613,
                  },
                }}
              >
                {Array.from(Array(4).keys()).map((el) => {
                  const index = el + 1;
                  // eslint-disable-next-line no-lone-blocks
                  {
                    return (
                      specData[`spec_${index}_image`] && (
                        <SwiperSlide>
                          <div className="mb-[26px] laptop:mb-5">
                            <Image
                              src={specData[`spec_${index}_image`]}
                              className="w-full aspect-[335/207] tablet:h-auto object-cover tablet:aspect-[858/532]"
                              alt={specData[`spec_${index}_title`]}
                              srcWidths={{
                                sm: 630,
                                md: 710,
                                lg: 620,
                                xl: 780,
                                '2xl': 800,
                              }}
                            />
                          </div>
                          <div className="mb-14">
                            {specData[`spec_${index}_title`] && (
                              <span className="block font-m-12 text-accent-1  mb-2 laptop:font-m-14">
                                {specData[`spec_${index}_title`]}
                              </span>
                            )}
                            {specData[`spec_${index}_header`] && (
                              <h4 className="heading-5 mb-3.5 text-primary-1 transition-colors laptop:heading-6 laptop:mb-3">
                                {specData[`spec_${index}_header`]}
                              </h4>
                            )}
                            {specData[`spec_${index}_text`] && (
                              <p className="font-r-14 text-primary-1 tracking-normal transition-colors max-w-[97%] tablet:max-w-[72%]">
                                {specData[`spec_${index}_text`]}
                              </p>
                            )}
                          </div>
                        </SwiperSlide>
                      )
                    );
                  }
                })}
              </Swiper>
              <button
                className="absolute hidden laptop:flex left-6 top-[240px]
                       z-1 swiper-button-prev-image-spec transition-all
                      bg-black border-black w-12 h-12 items-center
                        justify-center border disabled:hidden"
                ariaLabel="Previous button"
              >
                <ArrowIcon className="stroke-white" />
              </button>
              <button
                className="absolute hidden laptop:flex right-6 top-[240px]
                    z-1 swiper-button-next-image-spec transition-all
                    bg-black border-black rotate-180 w-12 h-12 items-center
                    justify-center border disabled:hidden"
                ariaLabel="Next button"
              >
                <ArrowIcon className="stroke-white" />
              </button>
            </div>
          </div>
        )}
      </>
    );
  };

  init();
  window.addEventListener('resize', init);
};
